import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';
import { handleResponseError } from '../../utils/helpers/error';

export const getOrders = createAsyncThunk('orders.getOrders', async ({
  page, limit, sortBy, domain
}, { rejectWithValue }) => {
  try {
    const queryParams = {
      page,
      limit,
    };

    if (sortBy) {
      queryParams.sortBy = sortBy;
    }

    if (domain) {
      queryParams.domain = domain;
    }

    const { data: { orders, totalDocs } } = await api.orders.getOrders(queryParams);
    return {
      orders,
      totalDocs,
    };
  } catch (error) {
    handleResponseError(error);
    return rejectWithValue();
  }
});

export const getOrder = createAsyncThunk('orders.getOrder', async ({
  orderId, onSuccess, onError
}, { rejectWithValue }) => {
  try {
    const { data: order } = await api.orders.getOrder(orderId);
    onSuccess(order);
    return order;
  } catch (error) {
    handleResponseError(error, onError);
    return rejectWithValue();
  }
});

export const addOrder = createAsyncThunk('orders.addOrder', async ({
  formData, onSuccess, onError
}, { rejectWithValue }) => {
  try {
    const { data: { order, message } } = await api.orders.addOrder(formData);
    onSuccess(message);
    return order;
  } catch (error) {
    handleResponseError(error, onError);
    return rejectWithValue();
  }
});

export const updateOrder = createAsyncThunk('orders.updateOrder', async ({
  formData, onSuccess, onError
}, { rejectWithValue }) => {
  try {
    const { data: { updatedOrder, message } } = await api.orders.updateOrder(formData);
    onSuccess(message);
    return updatedOrder;
  } catch (error) {
    handleResponseError(error, onError);
    return rejectWithValue();
  }
});
